import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  IconButton,
  HStack,
  Input,
  Textarea,
} from "@chakra-ui/react";

import { StarIcon } from "@chakra-ui/icons";

import ExpertB2BDataService from "../../services/ExpertB2B";
import { useState, useEffect } from "react";

export const RatingB2BExpertModal = ({
  isOpen,
  onClose,
  id,
  func,
}: any) => {
  const [rating, setRating] = useState("");

  const handleRating = () => {
    ExpertB2BDataService.updateRating(id, rating)
      .then((response: any) => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Rate the expert</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <HStack spacing={1}>
            {[1, 2, 3, 4, 5].map((star) => (
              <IconButton
                key={star}
                icon={<StarIcon />}
                aria-label={`Rate ${star}`}
                variant="ghost"
                color={star <= Number(rating) ? "yellow.400" : "gray.300"}
                onClick={() => setRating(star.toString())}
              />
            ))}
          </HStack>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color="white"
            mr={3}
            onClick={handleRating}
          >
            Submit
          </Button>
          <Button bgColor="gray" color="white" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
